import { SharedAppConstants } from '@tock/shared-app-constants';
import { replace } from 'es-toolkit/compat';

/**
 * Clear the list of patrons matching the given email address
 * @returns {Object} A redux action.
 */
export function clearSearch(): BaseTockAction {
  return {
    type: SharedAppConstants.PATRON_SEARCH_CLEAR,
  };
}

/**
 * Searches for patrons that contains the search string
 * @param {String} searchStringInput: The search fragment
 * @returns {Object} A redux TockApi action.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function searchForPatron(searchStringInput: any, requireEmails = false): ApiAction {
  const searchString = replace(searchStringInput, '@', ' ');
  return {
    TockApi: {
      getListProto: `/admin/patron/search?searchString=${searchString}&requireEmails=${requireEmails}`,
      type: SharedAppConstants.PATRON_SEARCH,
    },
  };
}
